import { Search, Package } from "lucide-react";
import { Button } from "../ui/button";
import { CategoryFilter } from "./StorePage";
interface EmptyStateProps {
  searchQuery: string;
  selectedCategory: CategoryFilter;
  onClearFilters: () => void;
}
export const EmptyState = ({ 
  searchQuery, 
  selectedCategory, 
  onClearFilters 
}: EmptyStateProps) => {
  const hasFilters = searchQuery || selectedCategory !== 'all';
  return (
    <div className="text-center py-16">
      <div className="w-24 h-24 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-6">
        {hasFilters ? (
          <Search className="w-12 h-12 text-gray-400" />
        ) : (
          <Package className="w-12 h-12 text-gray-400" />
        )}
      </div>
      
      <h3 className="text-xl font-semibold text-black mb-2">
        {hasFilters ? 'No Products Found' : 'No Products Available'}
      </h3>
      
      <p className="text-gray-600 mb-6 max-w-sm mx-auto">
        {hasFilters ? (
          <>
            We couldn&apos;t find any products matching your search
            {searchQuery && ` for "${searchQuery}"`}
            {selectedCategory !== 'all' && ` in ${selectedCategory}`}.
            Try adjusting your filters or search terms.
          </>
        ) : (
          'There are no products available at the moment. Please check back later.'
        )}
      </p>
      
      {hasFilters && (
        <Button
          onClick={onClearFilters}
          className="px-8 py-3 rounded-full font-semibold"
        >
          Clear All Filters
        </Button>
      )}
    </div>
  );
};